import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'video-chapters-container',
	templateUrl: './VideoChaptersContainer.Component.html'
})

export class VideoChaptersContainerComponent {
	@Input() public video: any;
	@Output() public onChapterClick: EventEmitter<any> = new EventEmitter();
}
